import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API } from '../../ApiNames';


export const fetch = (get: any) => ({
    type: 'fetch_GET_success',
    payload: get,
});

export const getSpecialityData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1};
            const apiname = Admin_API.plan_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetch(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
